import React from "react";
import SeoLandingPage from "./SeoLandingPage";

const page = {
  title: "Taxi Limassol | 24/7 Local Taxi and Airport Transfers",
  description:
    "Book a reliable taxi in Limassol for airport transfers, hotel pickups, city rides and long-distance trips across Cyprus.",
  canonical: "https://limassolairporttaxi.com/taxi-limassol",
  breadcrumbs: [
    { label: "Home", to: "/" },
    { label: "Taxi Services" },
    { label: "Taxi Limassol" },
  ],
  h1: "Taxi Limassol",
  heroText:
    "Need a taxi in Limassol? Book local rides, hotel pickups, airport transfers, marina transfers, and long-distance journeys across Cyprus.",
  snapshotLabel: "Local service",
  snapshotValue: "24/7 Taxi",
  snapshotText:
    "Taxi service in Limassol for residents, tourists, hotels, business travelers, airport passengers, and visitors exploring Cyprus.",
  overviewTitle: "Reliable taxi service in Limassol",
  overviewText:
    "Limassol is busy year-round, from seafront hotels and marina restaurants to business areas, old town streets, and airport travel. A dependable taxi makes local movement easier.",
  overviewCards: [
    {
      label: "City rides",
      title: "Hotels, marina, and old town",
      text: "Book rides between Limassol hotels, apartments, restaurants, offices, the marina, beaches, and nightlife areas.",
    },
    {
      label: "Airports",
      title: "Larnaca and Paphos transfers",
      text: "Arrange private taxi transfers from Limassol to either airport with direct pickup and flight-aware timing.",
    },
    {
      label: "Long distance",
      title: "Trips across Cyprus",
      text: "Travel from Limassol to Nicosia, Ayia Napa, Protaras, Troodos, villages, resorts, and event locations.",
    },
  ],
  whyTitle: "Why choose Limassol Airport Taxi for city rides",
  whyText:
    "Good local taxi service is about more than getting from one point to another. We focus on fast communication, clear details, and practical transport for real travel plans.",
  whyItems: [
    "Useful for tourists, residents, business visitors, and hotel guests",
    "Airport transfers plus local Limassol taxi requests",
    "Phone and WhatsApp booking for quick ride details",
    "Available for planned transfers and time-sensitive trips",
  ],
  routesTitle: "Popular taxi routes from Limassol",
  routesText:
    "From city rides to airport transfers, these pages connect the most requested Limassol taxi services.",
  popularRoutes: [
    {
      title: "Limassol to Larnaca Airport Taxi",
      to: "/limassol-to-larnaca-airport-taxi",
      text: "Book a direct taxi from Limassol to Larnaca Airport for departures and business travel.",
    },
    {
      title: "Limassol to Paphos Airport Taxi",
      to: "/limassol-to-paphos-airport-taxi",
      text: "Arrange a private taxi from Limassol to Paphos Airport for westbound flights.",
    },
    {
      title: "Larnaca Airport Taxi",
      to: "/larnaca-airport-taxi",
      text: "Airport taxi service between Limassol and Larnaca Airport with fast booking.",
    },
    {
      title: "Paphos Airport Taxi",
      to: "/paphos-airport-taxi",
      text: "Private taxi transfers connecting Limassol with Paphos Airport.",
    },
  ],
  infoTitle: "Taxi and airport transfer information for Limassol",
  infoText:
    "Tell us your pickup point, destination, preferred time, passenger count, luggage, and any flight details. For airport rides, sharing the flight number helps align timing.",
  infoDetails: [
    ["Location", "Limassol, Cyprus"],
    ["Services", "Local taxi and airport transfers"],
    ["Booking", "Phone or WhatsApp"],
    ["Availability", "24/7 by request"],
    ["Airport routes", "Larnaca Airport and Paphos Airport"],
    ["Trip types", "Hotels, homes, offices, resorts, airports"],
  ],
  availabilityTitle: "Limassol taxis available day and night",
  availabilityText:
    "From early airport pickups to late dinners, events, meetings, and weekend trips, you can request a Limassol taxi when your schedule needs reliable transport.",
  faqTitle: "Taxi Limassol FAQ",
  faqs: [
    {
      question: "Can I book a taxi anywhere in Limassol?",
      answer:
        "You can request pickup from hotels, homes, apartments, offices, marina areas, old town, beaches, and nearby Limassol neighborhoods.",
    },
    {
      question: "Do you provide airport transfers from Limassol?",
      answer:
        "Yes. Airport transfers are available from Limassol to Larnaca Airport and Paphos Airport, as well as arrivals back to Limassol.",
    },
    {
      question: "Can I arrange a taxi by WhatsApp?",
      answer:
        "Yes. Send your pickup address, destination, date, time, passengers, and luggage by WhatsApp for a quick response.",
    },
    {
      question: "Do you offer long-distance taxis from Limassol?",
      answer:
        "Yes. Long-distance taxi trips can be arranged to Nicosia, Ayia Napa, Protaras, Troodos, airports, villages, and resorts.",
    },
    {
      question: "Is the taxi service available late at night?",
      answer:
        "Taxi requests can be arranged 24/7 by request, including late-night rides and early airport pickups.",
    },
  ],
};

export default function TaxiLimassolPage() {
  return <SeoLandingPage page={page} />;
}
